import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { mobilePoint } from 'src/styles/globalStyle';
import PlaceImg from 'src/components/ui-kit/PlaceImg';
import DetailBanner from 'src/components/layout/banner/DetailBanner';
import { PrimaryColors } from 'src/types/globalTypes';
import SideList from 'src/components/layout/list/SideList';
import { useLocation } from 'react-router-dom';
import patentDirectionIcon from 'src/assets/images/direction/patent_direction_icon.svg';
import tmarkDirectionIcon from 'src/assets/images/direction/tmark_direction_icon.svg';
import certDirectionIcon from 'src/assets/images/direction/cert_direction_icon.svg';
import directionIcon from 'src/assets/images/direction/direction_icon.svg';
import { useStore } from 'src/hooks/useStore';
import DirectionMobileList from './DirectionMobileList';
import ToTop from 'src/components/ui-kit/ToTop';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 39px;
  height: max-content;
`;
const ImgDiv = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  @media (max-width: ${mobilePoint}) {
    display: none;
  }
`;
const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  width: 80%;
  gap: 3em;
  margin: 3em 0;

  @media (max-width: ${mobilePoint}) {
    grid-template-columns: 1fr;
    margin: 0;
    width: 100%;
    gap: 0;
  }
`;
const Icon = styled.img``;

// 輸出樣式
export const ContentWrapper = styled.div`
  display: grid;
  gap: 1.5em;
`;
export const MainContent = styled.div`
  background-color: ${colors.white};
  box-shadow: 0 0 5px rgba(67, 67, 67, 0.08);
  width: 100%;
  border-radius: 4px;
  padding: 2em;
  line-height: 2em;
  @media (max-width: ${mobilePoint}) {
    background-color: transparent;
    box-shadow: none;
  }
`;
export const SubTitle = styled.div`
  font-family: NotoSansTC-Bold;
  font-size: 18px;
`;
export const Text = styled.p`
  text-indent: -1em;
  margin-left: 1em;
`;
export const BoldText = styled.p`
  font-family: NotoSansTC-Bold;
`;
export const TextAnnotation = styled.p`
  color: ${colors.BlueGray_500};
`;
export const Img = styled.img`
  width: 100%;
`;
export const Annotation = styled.div`
  color: ${colors.BlueGray_500};
  margin-bottom: 1.5em;

  @media (max-width: ${mobilePoint}) {
    margin: 0 1.5em 1.5em 1.5em;
  }
`;

interface Iprops {
  title?: string;
  children: React.ReactNode;
  bannerBgImg: string;
  image: string;
  imgDot: string;
  bgColor: PrimaryColors;
}

/**
 * 操作說明功能頁
 */
const DirectionPage: React.FC<Iprops> = ({
  title,
  children,
  bannerBgImg,
  bgColor,
  image,
  imgDot,
}) => {
  const isMobile = useStore((state) => state.isMobile);
  const { pathname } = useLocation();
  const mainTitle = title ? title : '操作說明';
  const listColor = pathname.startsWith(process.env.PUBLIC_URL + '/certificate') ? bgColor.fifth : bgColor.seventh;
  // 取得該項目當前icon
  const getIcon = (pathNow: string) => {
    const isActive = pathname.startsWith(process.env.PUBLIC_URL + pathNow);
    if (isActive) {
      switch (pathNow) {
        case '/patentRights':
          return <Icon src={patentDirectionIcon} alt="" />;
        case '/trademarkRights':
          return <Icon src={tmarkDirectionIcon} alt="" />;
        case '/certificate':
          return <Icon src={certDirectionIcon} alt="" />;
        case '/qrcode':
          return <Icon src={tmarkDirectionIcon} alt="" />;
        default:
          return <Icon src={directionIcon} alt="" />;
      }
    } else {
      return <Icon src={directionIcon} alt="" />;
    }
  };
  const sideList = [
    { title: '專利權證', href: process.env.PUBLIC_URL + '/patentRights/direction', icon: getIcon('/patentRights') },
    { title: '商標權證', href: process.env.PUBLIC_URL + '/trademarkRights/direction', icon: getIcon('/trademarkRights') },
    { title: '電子證書', href: process.env.PUBLIC_URL + '/certificate/direction', icon: getIcon('/certificate') },
    { title: '掃描QR code', href: process.env.PUBLIC_URL + '/qrcode/direction', icon: getIcon('/qrcode') },
  ];
  const subtitle = sideList.filter((item) => item.href === pathname)[0].title;
  const mobileList = sideList.map((item) => {
    return { label: item.title, value: item.href };
  });

  return (
    <>
      {isMobile && <ToTop />}
      <ImgDiv>
        <ImgDiv>
          <PlaceImg image={imgDot} placeProps={{ height: '80px', top: '20%', right: '0%' }} />
          <PlaceImg image={imgDot} placeProps={{ height: '80px', top: '40%', left: '0%' }} />
        </ImgDiv>
      </ImgDiv>
      <Wrapper>
        <DetailBanner
          title={mainTitle}
          subtitle={subtitle}
          bgImg={bannerBgImg}
          image={image}
          bgColor={bgColor.sixth}
        />
        <Content>
          {isMobile ? (
            <DirectionMobileList options={mobileList} colorType={bgColor} />
          ) : (
            <SideList components={sideList} color={listColor} />
          )}
          {children}
        </Content>
      </Wrapper>
    </>
  );
};

export default DirectionPage;
